import type { CompsTableCommissionType } from "@platform/api";

export const COMMISSION_TYPE_VALUES: readonly CompsTableCommissionType[] = [
  "net",
  "percentage",
  "pepm",
  "heaped",
  "graded",
  "standard",
  "notApplicable",
  "notDisclosed",
];

export const COMMISSION_TYPE_LABELS: Record<CompsTableCommissionType, string> =
  {
    net: "Net",
    percentage: "Percentage",
    pepm: "PEPM",
    heaped: "Heaped",
    graded: "Graded",
    standard: "Carrier Standard",
    notApplicable: "Not Applicable",
    notDisclosed: "Not Disclosed",
    notRequested: "N/A",
    notSupported: "N/A",
    notQuoted: "N/A",
    dtq: "DTQ",
  };

export const DISABLED_AMOUNT_TYPES = [
  "net",
  "standard",
  "notDisclosed",
  "notApplicable",
];

/** Commission type values that come from the backend as read-only — the cell is not editable. */
export const DISABLED_COMMISSION_TYPE_VALUES: readonly CompsTableCommissionType[] =
  ["notRequested", "notSupported", "notQuoted", "dtq"];
